import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './ProductDetailsOwnerProducts.sss';

interface Props {
  className?: string,
}

export const ProductDetailsOwnerProductsSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <Skeleton
        width='150px'
        height='24px'
      />

      <ul className={s.list}>
        {Array(4).fill(null).map((_, i) => (
          <li
            key={i}
            className={s.item}
          >
            <Skeleton
              width='100%'
              height='235px'
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
